import { useState, useEffect } from 'react';

var BreakpointPixelValue;
(function (BreakpointPixelValue) {
    BreakpointPixelValue[BreakpointPixelValue["SM"] = 640] = "SM";
    BreakpointPixelValue[BreakpointPixelValue["MD"] = 768] = "MD";
    BreakpointPixelValue[BreakpointPixelValue["LG"] = 1024] = "LG";
    BreakpointPixelValue[BreakpointPixelValue["XL"] = 1280] = "XL";
    BreakpointPixelValue[BreakpointPixelValue["2XL"] = 1536] = "2XL";
})(BreakpointPixelValue || (BreakpointPixelValue = {}));
var Breakpoints;
(function (Breakpoints) {
    Breakpoints["SM"] = "(min-width: 640px)";
    Breakpoints["MD"] = "(min-width: 768px)";
    Breakpoints["LG"] = "(min-width: 1024px)";
    Breakpoints["XL"] = "(min-width: 1280px)";
    Breakpoints["2XL"] = "(min-width: 1536px)";
})(Breakpoints || (Breakpoints = {}));
const useMediaQuery = (query, fallback = true) => {
    const [matches, setMatches] = useState();
    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = () => setMatches(media.matches);
        window.addEventListener('resize', listener);
        return () => window.removeEventListener('resize', listener);
        // eslint-disable-next-line
    }, [query]);
    return matches ?? fallback;
};

export { BreakpointPixelValue, Breakpoints, useMediaQuery };
//# sourceMappingURL=use-media-query.js.map
